// import { EMAIL_VALIDATE_REGEX } from '@/configs/constants';
import { Button } from '@/components/common/Button';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/common/Form';
import { Input } from '@/components/common/Input';
import { Label } from '@/components/common/Label';
import { Textarea } from '@/components/common/Textarea';
import { ACTIVITY_COLOR, ITEMS_STATUS } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { ITEM_ACTIVITY, ITEM_STATUS, ITEM_TYPE } from '@/types/enums';
import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type Props = {
    item?: any
};
export default observer(function ViewItem({ item }: Props) {
    // hooks
    const { t } = useTranslation();

    // store
    const {
        modalStore: { hideModal }
    } = useStore();

    // validate schema
    const form = useForm();

    // state

    // life cycle
    useEffect(() => {
        if (item) {
            form.setValue('item', item?.item);
            form.setValue('description', item?.description);
            form.setValue('cover', item?.file?.path);
            form.setValue('itemType', item?.itemType);
            form.setValue('type', item?.type);
            form.setValue('location', item?.location);
            form.setValue('address', item?.address);
            form.setValue('latitude', item?.latitude);
            form.setValue('longitude', item?.longitude);
            form.setValue('status', item?.status);
            form.setValue('reason', item?.reason);
        }
    }, []);

    // functions

    const statusItem = ITEMS_STATUS.find(i => i.id === item?.status);
    const activityItem = ACTIVITY_COLOR.find(i => i.id === item?.activity);

    return (
        <>

            <div>
                <Form {...form}>
                    <form>
                        <div className='border border-background-6 pb-4 !rounded-[5px]'>
                            <div className='px-6 py-3 text-[15px] font-semibold bg-background-6 rounded-t-sm'>
                                {t('words_title.item_info')}
                            </div>
                            <div className='mt-4 px-6'>
                                <div className='grid grid-cols-2 space-x-4'>
                                    <div>
                                        <FormField
                                            control={form.control}
                                            name='item'
                                            render={({ field }) => (
                                                <>
                                                    <FormItem>
                                                        <Label className='mb-2'>
                                                            {t('field.item_name')}
                                                        </Label>
                                                        <FormControl>
                                                            <Input
                                                                disabled
                                                                className='disabled:cursor-default disabled:opacity-100 disabled:text-text-normal disabled:text-[15px] disabled:bg-background-7'
                                                                {...field}
                                                            />
                                                        </FormControl>
                                                    </FormItem>
                                                    <FormMessage className='mt-1' />
                                                </>
                                            )}
                                        />
                                        <FormField
                                            control={form.control}
                                            name='description'
                                            render={({ field }) => (
                                                <>
                                                    <Label className='mt-4'>
                                                        {t('field.descroption')}
                                                    </Label>
                                                    <FormItem className='w-full'>
                                                        <FormControl>
                                                            <Textarea
                                                                disabled
                                                                className='resize-none h-[13.575rem] mt-2 disabled:cursor-default disabled:opacity-100 disabled:text-text-normal disabled:text-[15px] disabled:bg-background-7 whitespace-pre-line'
                                                                {...field}
                                                            />
                                                        </FormControl>
                                                    </FormItem>
                                                    <FormMessage className='mt-1' />
                                                </>
                                            )}
                                        />
                                    </div>
                                    {
                                        item?.file?.path && (
                                            <div className='h-full'>
                                                <FormField
                                                    control={form.control}
                                                    name='cover'
                                                    render={({ field }) => (
                                                        <div className='h-full flex flex-col'>
                                                            <Label className='mb-2'>
                                                                {t('field.cover')}
                                                            </Label>
                                                            <FormItem className='w-full flex-1'>
                                                                <FormControl>
                                                                    <div
                                                                        className={`h-full w-full border-[1.5px] rounded-lg flex flex-col items-center justify-center bg-white relative ${form?.formState?.errors.cover ? 'border-[#ef4444] rounded-lg' : 'border-input bg-background-input rounded-lg'}`}
                                                                    >
                                                                        <div className='text-center h-full w-full'>
                                                                            <img
                                                                                src={item?.file?.path}
                                                                                alt='Preview'
                                                                                className='w-full h-[312px] object-contain rounded-lg'
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </FormControl>
                                                            </FormItem>
                                                            <FormMessage className='mt-1' />
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        )
                                    }

                                </div>
                                <div className='mt-4'>
                                    <Label>{t('field.location')}</Label>
                                    <div className='flex mt-[10px]'>
                                        <Label className='w-[20%] text-text-gray-1'>
                                            {t('field.address')}
                                        </Label>
                                        <p className='flex-1 font-semibold break-all'>{item?.address}</p>
                                    </div>
                                    <div className='flex mt-[10px]'>
                                        <Label className='w-[20%] text-text-gray-1'>
                                            {t('field.latitude')}
                                        </Label>
                                        <p className='flex-1 text-active font-semibold break-all'>{item?.latitude}</p>
                                    </div>
                                    <div className='flex mt-[10px]'>
                                        <Label className='w-[20%] text-text-gray-1'>
                                            {t('field.longitude')}
                                        </Label>
                                        <p className='flex-1 text-active font-semibold break-all'>{item?.longitude}</p>
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <div className='flex mt-[10px] items-center'>
                                        <Label className='w-[20%]'>
                                            {t('field.item_type')}
                                        </Label>
                                        <Button type='button' variant='default' className='bg-gradient-to-r from-[#EA4335] to-[#F47843] cursor-default px-4 h-[22px] text-white !rounded-[6px] text-[15px]'>
                                            {item?.itemType === ITEM_TYPE.COUPON ? t('field.coupon') : t('field.not_set')}
                                        </Button>
                                    </div>
                                    {
                                        item?.itemType === ITEM_TYPE.COUPON && (
                                            <div className='flex mt-[10px]'>
                                                <Label className='w-[20%] text-text-gray-1'>
                                                    {t('field.coupon_code')}
                                                </Label>
                                                <p className='flex-1 font-semibold'>{item?.code}</p>
                                            </div>
                                        )
                                    }
                                    <div className='flex mt-[10px]'>
                                        <Label className='w-[20%] text-text-gray-1'>{t('field.status')}</Label>
                                        <p className='flex-1 text-active font-semibold'>
                                            {statusItem && (
                                                <div className={`${statusItem?.textColor}`}>
                                                    {t(statusItem?.name)}
                                                </div>
                                            )}
                                        </p>
                                    </div>
                                    {
                                        (item.status !== ITEM_STATUS.UN_PUBLISHED) && (
                                            <div className='flex mt-[10px] items-center'>
                                                <Label className='w-[20%] text-text-gray-1'>{t('field.activity_status')}</Label>
                                                <p className='flex-1 text-active font-semibold'>
                                                    {activityItem && (
                                                        <Button type='button' variant='default' className={`${activityItem?.style} cursor-default px-4 h-[26px] text-white !rounded-[6px] text-[15px]`}>
                                                            {' '}
                                                            {t(activityItem?.name)}
                                                        </Button>
                                                    )}
                                                </p>
                                            </div>
                                        )
                                    }
                                </div>
                                {
                                    ((item?.status === ITEM_STATUS.PRIVATE) && item?.activity === ITEM_ACTIVITY.PRIVATE__WITHDRAWAL) && (
                                        <div className='mt-4'>
                                            <FormField
                                                control={form.control}
                                                name='reason'
                                                render={({ field }) => (
                                                    <>
                                                        <Label>{t('field.reason')}</Label>
                                                        <FormItem className='w-full'>
                                                            <FormControl>
                                                                <Textarea
                                                                    disabled
                                                                    className='resize-none h-[6.875rem] mt-2 disabled:cursor-default disabled:opacity-100 disabled:text-text-normal disabled:text-[15px] disabled:bg-background-7'
                                                                    {...field}
                                                                />
                                                            </FormControl>
                                                        </FormItem>
                                                        <FormMessage className='mt-1' />
                                                    </>
                                                )}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <div className='mt-6 pb-6 flex justify-center items-center space-x-[10px]'>
                            <Button
                                type='button'
                                variant='outline'
                                className={cn('w-[10rem] h-12 text-[15px] font-semibold hover:text-text-black-1 border border-border-button text-text-black-1 !rounded-[10px]')}
                                onClick={() => hideModal()}
                            >
                                {t('button.cancel_2')}
                            </Button>
                        </div>
                    </form>
                </Form>
            </div>
        </>
    );
});
